/**
 * SectionBlock — labeled section primitive used across detail surfaces
 * (Block 6.A / surfaces 2 + 3).
 *
 * Two variants (UX-13 S0, per the reconciled gate — this REPLACES the
 * planned DataSection so there is no third section primitive beside
 * this and DrawerSection, which remains the drawer-internal band only):
 *   - 'divider' (default, byte-identical to the original): the
 *     wireframe's `━━━━━ HEADING ━━━━━` header followed by content.
 *   - 'card': the ruled paper section for detail pages — bg-paper,
 *     rounded-card, sh1 (flatter than the entity card's sh2: on a
 *     detail page the entity IS the page), p-6, display-serif title.
 */

import type { ReactNode } from 'react';

export interface SectionBlockProps {
  title: string;
  variant?: 'divider' | 'card';
  children: ReactNode;
}

export function SectionBlock({ title, variant = 'divider', children }: SectionBlockProps): ReactNode {
  if (variant === 'card') {
    return (
      <section className="rounded-card bg-paper shadow-sh1 border border-sage-800/[8%] p-6">
        <h2 className="font-display text-lg text-sage-800 mb-3">{title}</h2>
        <div className="text-sm text-ink">{children}</div>
      </section>
    );
  }
  return (
    <section className="py-3 border-t border-sage-800/[8%]">
      <h2 className="text-xs font-semibold uppercase tracking-wide text-ink-soft mb-2">
        {title}
      </h2>
      <div className="text-sm text-ink">{children}</div>
    </section>
  );
}
